// extracted by mini-css-extract-plugin
export default {"wrapper":"ContentsHeader_wrapper__hnTB-","title":"ContentsHeader_title__HiY6K"};